import { z } from 'zod';
import { BaseAuthUserDTOSchema } from "./auth.dto.js";
// Input DTO for getting current user (just needs userId)
export const GetCurrentUserInputDTOSchema = z.object({
    userId: BaseAuthUserDTOSchema.shape.id,
});
// Output DTO schema
export const GetCurrentUserOutputDTOSchema = BaseAuthUserDTOSchema.pick({
    id: true,
    name: true,
    email: true,
    emailVerified: true,
    userType: true,
    defaultCompanyId: true,
});
// Request and response schemas for API layer
export const GetCurrentUserRequestDTOSchema = z.object({});
//# sourceMappingURL=get-current-user.dto.js.map